import { FETCH_BULK_ACTION_LIST_FAILURE, FETCH_BULK_ACTION_LIST_REQUEST, FETCH_BULK_ACTION_LIST_REST, FETCH_BULK_ACTION_LIST_SUCCESS } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getBulkActionsListReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BULK_ACTION_LIST_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_BULK_ACTION_LIST_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case FETCH_BULK_ACTION_LIST_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case FETCH_BULK_ACTION_LIST_REST:
            return Object.assign(Object.assign({}, state), { loading: false, data: null });
        default:
            return state;
    }
};
export default getBulkActionsListReducer;
